// extracted by css-extract-rspack-plugin
export default {"Link":"Link-module__Link__k1RQ7","Icon":"Link-module__Icon__P7ozT"};